import { ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const abonnementValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const opkraevningsinterval = control.get('opkraevningsinterval');
  const eftersynInterval = control.get('eftersynInterval');

  return opkraevningsinterval?.value && eftersynInterval?.value && eftersynInterval?.value % opkraevningsinterval?.value != 0
    ? { opkraevningsinterval: true }
    : null;
};
